import { render, staticRenderFns } from "./ValeColacion.vue?vue&type=template&id=2df4dc9a&"
import script from "./ValeColacion.vue?vue&type=script&lang=js&"
export * from "./ValeColacion.vue?vue&type=script&lang=js&"
import style0 from "./ValeColacion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports